export const TOMCAT_WEBAPP_URL:string = 'https://christmaslist.michaelsutton.net';